export const GA_TRACKING_ID = process.env.GTAG // החלף עם מזהה המעקב שלך

// אירוע צפייה בדף
export const pageview = (url) => {
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  })
}

// אירוע אחר
export const event = ({ action, category, label, value }) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}